import React, {useState, useEffect} from 'react'
import {Button, Form, Input, Modal, AutoComplete, InputNumber} from "antd";
import {createStock, getAllStockCodes} from "../../services/serviceStock";
import {getAllWarehouse} from "../../services/serviceWarehouse";
import {getAllBrand} from "../../services/serviceBrand";
import {getAllCategory} from "../../services/serviceCategory";
import {createAll} from "../../services/serviceInventory";
import StockWarehouseQuantity from "./StockWarehouseQuantity";
import config from "../../config";
import {enterLoadingState, exitLoadingState} from "../../utils/helpers/commonFunctions";


const Option = AutoComplete.Option
const {TextArea} = Input
const formLayout = {labelCol: {span: 8}, wrapperCol: {span: 16}}
const currencyOptions = [
    {value: 'TRY'},
    {value: 'USD'},
    {value: 'EUR'},
];

const StockCreate = ({show, modalCloser, updater, bubbleResponse = false}) => {
    const [form] = Form.useForm()
    const [warehouseList, setWarehouseList] = useState([])
    const [brands, setBrands] = useState([])
    const [categories, setCategories] = useState([])
    const [createdCategory, setCreatedCategory] = useState('')
    const [cretedBrand, setCreatedBrand] = useState('')
    const [bulkWarehouse, setBulkWarehouse] = useState([])
    const [loadings, setLoadings] = useState([])
    const [stockCodes, setStockCodes] = useState([])


    useEffect(() => {
        getAllWarehouse()
            .then(({data}) => {
                const initBulkWarehouse = data.map(item => {
                    return {
                        warehouse: {
                            id: item.id
                        },
                        quantity: 0
                    }
                })
                setBulkWarehouse(initBulkWarehouse)
                setWarehouseList(data)
            })
    }, [])

    useEffect(() => {
        getAllStockCodes()
            .then(({data}) => setStockCodes(data))
    }, [])

    useEffect(() => {
        getAllBrand()
            .then(({data}) => {
                let brandsData = []
                data.forEach(item => {
                    let pushObj = {
                        value: item.id,
                        text: item.code
                    }
                    brandsData.push(pushObj)
                })
                setBrands(brandsData)
            })
    }, [])

    useEffect(() => {
        getAllCategory()
            .then(({data}) => {
                let categoryData = []
                data.forEach(item => {
                    let pushObj = {
                        value: item.id,
                        text: item.code
                    }
                    categoryData.push(pushObj)
                })
                setCategories(categoryData)
            })
    }, [])

    const handleSubmit = (list) => {
        enterLoadingState(setLoadings)

        const requestObj = {
            name: list.stockName,
            code: list.stockCode,
            description: list.stockDescription,
            price: list.stockPrice,
            currency: list.stockCurrency.toUpperCase(),
            unit: list.stockUnit,
            criticalThresdhold: list.stockThreshold,
            brandId: cretedBrand,
            firmStockCode: list.firmStockCode,
            categoryId: createdCategory
        }

        createStock(requestObj)
            .then(({data}) => {
                if (bulkWarehouse.length) {
                    let bulkList = bulkWarehouse.map(item => ({
                        stock: {id: data.id},
                        warehouse: item.warehouse,
                        quantity: item.quantity
                    }))
                    createAll(bulkList)
                        .then(({data: inventoryData}) => {
                            exitLoadingState(setLoadings)
                            modalCloser()
                            updater(bubbleResponse ? {stockData: data, inventoryData} : null)
                        })
                }
            })
            .catch(() => exitLoadingState(setLoadings))
    }
    const handleBrandChange = (value, option) => setCreatedBrand(option.key)
    const handleCategoryChange = (value, option) => setCreatedCategory(option.key)
    const appendBulkWarehouse = (quantity, warehouseId) => {
        const mockState = bulkWarehouse
        const warehouseItem = mockState.find((item) => item.warehouse.id === warehouseId)

        if (warehouseItem) {
            warehouseItem.quantity = quantity
            setBulkWarehouse([...mockState])
            return
        }

        setBulkWarehouse([...mockState, {quantity: quantity, warehouse: {id: warehouseId}}])
    }

    return (
        <React.Fragment>
            <Modal
                open={show}
                closable={false}
                title={'Yeni Stok Ekle'}
                footer={[
                    <Button type={'primary'}
                            key={'SubmitButton'}
                            onClick={() => form.submit()}
                            loading={loadings[0]}
                    >Kaydet</Button>,
                    <Button key={'CancelButton'} onClick={() => modalCloser()}>Kapat</Button>
                ]}
            >
                <Form
                    form={form}
                    labelAlign={'left'}
                    {...formLayout}
                    onFinish={() => handleSubmit(form.getFieldsValue())}
                >

                    <Form.Item
                        label={'Stok Adı'}
                        name={'stockName'}
                        rules={[
                            {required: true, message: 'Stok Adı Boş Bırakılamaz'},
                            {min: 5, max: 300, message: 'Stok Adı En Az 5 En Fazla 300 Karakter Olabilir'}
                        ]}
                    >
                        <Input/>
                    </Form.Item>
                    <Form.Item
                        label={'Stok Kodu'}
                        name={'stockCode'}
                        rules={[
                            {required: true, message: 'Stok Kodu Boş Bırakılamaz'},
                            {pattern: /^\S*$/gm, message: 'Stok Kodu Alanı Boşluk İçeremez'},
                            {min: 0, max: 250, message: 'Stok Kodu En az 0 En Fazla 250 Karakter Olabilir'},
                            () => ({
                                validator(rule, value) {
                                    if (value) {
                                        const hasValue = stockCodes.filter(({c}) => c.toLowerCase() === value.toLowerCase())
                                        if (!hasValue.length) {
                                            return Promise.resolve();
                                        }
                                    }

                                    return Promise.reject('Lütfen Var Olmayan Bir Değer Giriniz');
                                },
                            })

                        ]}
                    >
                        <AutoComplete
                            filterOption={(inputValue, option) =>
                                option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                            }
                        >
                            {stockCodes.map(({c}) => (
                                <Option key={c} value={c}>{c}</Option>
                            ))}
                        </AutoComplete>
                    </Form.Item>
                    <Form.Item
                        label={'Firma Stok Kodu'}
                        name={'firmStockCode'}
                        rules={[
                            {max: 300, message: 'Firma Stok Kodu Alanı En Fazla 300 Karakter Olabilir'}
                        ]}
                    >
                        <Input/>
                    </Form.Item>
                    <Form.Item
                        label={'Stok Açıklaması'}
                        name={'stockDescription'}
                        rules={[
                            {max: 100, message: 'Açıklama Alanı En Fazla 100 Karakter Olabilir'}
                        ]}
                    >
                        <TextArea/>
                    </Form.Item>
                    <Form.Item
                        label={'Marka'}
                        name={'stockBrand'}
                        rules={[
                            {required: true, message: 'Lütfen Bir Marka Seçiniz'},
                            () => ({
                                validator(rule, value) {
                                    if (value) {
                                        const hasValue = brands.filter(brand => brand.text.toLowerCase() === value.toLowerCase())
                                        if (hasValue.length) {
                                            handleBrandChange(true, {key: hasValue[0].value})
                                            return Promise.resolve();
                                        }
                                    }

                                    return Promise.reject('Lütfen Geçerli Bir Değer Giriniz');
                                },
                            }),
                        ]}
                    >
                        <AutoComplete
                            filterOption={(inputValue, option) =>
                                option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                            }
                        >
                            {brands.map(({value, text}) => (
                                <Option key={value} value={text}>{text}</Option>
                            ))}
                        </AutoComplete>
                    </Form.Item>
                    <Form.Item
                        label={'Kategori'}
                        name={'stockCategory'}
                        rules={[
                            {required: true, message: 'Lütfen Bir Kategori Seçiniz'}
                        ]}
                    >
                        <AutoComplete
                            onChange={handleCategoryChange}
                            filterOption={(inputValue, option) =>
                                option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                            }
                        >
                            {categories.map(({value, text}) => (
                                <Option key={value} value={text}>{text}</Option>
                            ))}
                        </AutoComplete>

                    </Form.Item>
                    <Form.Item
                        label={'Birim'}
                    >
                        {/*<Form.Item*/}
                        {/*    name={'stockQuantity'}*/}
                        {/*    initialValue={1}*/}
                        {/*    noStyle*/}
                        {/*    rules={[*/}
                        {/*        {required: true, message: 'Lütfen Adet Giriniz'}*/}
                        {/*    ]}*/}
                        {/*>*/}
                        {/*    <InputNumber step={0.1} style={{width: '50%'}}/>*/}
                        {/*</Form.Item>*/}

                        <Form.Item
                            name={'stockUnit'}
                            noStyle
                            initialValue={config.stockUnits[0].value}
                            rules={[
                                {required: true, message: 'Lütfen Birim Seçiniz'},
                                () => ({
                                    validator(rule, value) {
                                        let hasValue = config.stockUnits.filter(unit => unit.value.toLowerCase() === value.toLowerCase())
                                        if (value && hasValue.length > 0) {
                                            return Promise.resolve();
                                        }

                                        return Promise.reject('Lütfen Geçerli Bir Değer Giriniz');
                                    },
                                }),
                            ]}
                        >
                            <AutoComplete
                                options={config.stockUnits}
                                style={{width: '150px'}}
                                filterOption={(inputValue, option) =>
                                    option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                }
                            />
                        </Form.Item>

                    </Form.Item>

                    <Form.Item
                        label={'Fiyat&Para Birimi'}
                    >
                        <Input.Group compact>
                            <Form.Item
                                name={'stockPrice'}
                                noStyle
                                rules={[
                                    {required: true, message: 'Lütfen Fiyat Giriniz'},
                                    {type: 'number', min: 0, message: 'Fiyat Alanı En Az 0 Olmalıdır'}
                                ]}
                                initialValue={0}
                            >
                                <InputNumber step={0.1} min={0} style={{width: '50%'}}/>
                            </Form.Item>
                            <Form.Item
                                name={'stockCurrency'}
                                noStyle
                                rules={[
                                    {required: true, message: 'Para Birimi Boş Bırakılamaz'},
                                    () => ({
                                        validator(rule, value) {
                                            if (value) {
                                                let hasValue = currencyOptions.filter(unit => unit.value.toUpperCase() === value.toUpperCase())
                                                if ( hasValue.length ) {
                                                    return Promise.resolve();
                                                }
                                            }

                                            return Promise.reject('Lütfen Geçerli Bir Değer Giriniz');
                                        },
                                    }),
                                ]}
                            >
                                <AutoComplete
                                    options={currencyOptions}
                                    style={{width: '100px'}}
                                    filterOption={(inputValue, option) =>
                                        option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                    }
                                />
                            </Form.Item>
                        </Input.Group>
                    </Form.Item>

                    {
                        warehouseList.map((item, index) => (
                            <StockWarehouseQuantity key={index} warehouseName={item.name} warehouseId={item.id}
                                                    updateBulkList={appendBulkWarehouse}/>
                        ))
                    }

                    <Form.Item
                        label={'Alt Limit'}
                        name={'stockThreshold'}
                        initialValue={0}
                        rules={[
                            {required: true, message: 'Alt Limit Alanı Boş Bırakılamaz'},
                            {type: 'number', min: 0, message: 'Alt Limit Alanı En Az 0 Olabilir'}
                        ]}
                    >
                        <InputNumber min={0} step={0.1}/>
                    </Form.Item>
                </Form>
            </Modal>
        </React.Fragment>
    )
}
export default StockCreate
